import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
	selector: 'app-order-not-exist-modal',
	templateUrl: './order-not-exist-modal.component.html',
	styleUrls: ['./order-not-exist-modal.component.scss'],
	standalone: false,
})
export class OrderNotExistModalComponent implements OnInit {
	public isInMenu = false;

	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController, isInMenu: boolean = false): Promise<boolean> {
		const modal = await modalCtrl.create({
			cssClass: 'item-modal',
			component: OrderNotExistModalComponent,
			componentProps: {
				isInMenu,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	ngOnInit() {}

	dismiss() {
		this.modalCtrl.dismiss();
	}

	closeWithTrue() {
		this.modalCtrl.dismiss(true);
	}
}
